import React, { memo } from 'react'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import { useFormikContext } from 'formik'
import { ReviewDateField } from 'src/components/document-review/review/ReviewDateField'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { McReviewFormValues } from 'src/interfaces/documentReview'
import { resolveReviewDateBounds } from 'src/utils/documentReviewDates'

/**
 * No First/Last name fields: `PartnerCollectedDataReviewMetadataDto` does not declare them, so
 * anything typed there would be stripped by the backend. See the design's divergence #3.
 *
 * Dates use `ReviewDateField`, not `FormikDatePicker` — `McReviewFormValues` types both dates as
 * plain ISO strings, and `FormikDatePicker` would write a `Dayjs` object into Formik state
 * instead.
 */
const McReviewFormContentComponent = () => {
  const { values } = useFormikContext<McReviewFormValues>()
  const { expirationMin } = resolveReviewDateBounds({
    dateIssued: values.dateIssued,
    expiresAt: values.expiresAt,
  })

  return (
    <div css={tw`flex max-w-2xl flex-col gap-4`}>
      <FormikTextField<McReviewFormValues> name="documentId" label="Document ID" />
      <div css={tw`grid grid-cols-2 gap-4`}>
        <ReviewDateField<McReviewFormValues> name="dateIssued" label="Issue date" />
        <ReviewDateField<McReviewFormValues>
          name="expiresAt"
          label="Expiration date *"
          minDate={dayjs(expirationMin)}
        />
      </div>
    </div>
  )
}

export const McReviewFormContent = memo(McReviewFormContentComponent)
